<div id="zoom-container" [ngClass]="{'vertical': axis=='vertical'}">
  <button (click)=onZoomIn()  mat-mini-fab class="map-control zoomin mat-elevation-z0" >
    <mat-icon>add</mat-icon>
  </button>
  <button (click)=onZoomOut() mat-mini-fab class="map-control zoomout" >
    <mat-icon>remove</mat-icon>
  </button>
  @if (zoomAllBtn) {
    <button (click)=onZoomAll() mat-mini-fab  class="map-control zoomall"  >
      <mat-icon  fontSet="ngi" fontIcon="belgium"></mat-icon>
    </button>
  }
  @if (geolocation) {
    <tt-geolocation></tt-geolocation>
  }
</div>